import { Link } from "react-router-dom";
import { ActionButton, actionLinkClasses } from "@/components/ui/ActionButton";
import { useAuth } from "@/contexts/AuthContext";
import type { Nit } from "@/api/nits";

interface NitRowProps {
  nit: Nit;
  onView: (nit: Nit) => void;
  onDelete: (nit: Nit) => void;
}

export const NitRow = ({ nit, onView, onDelete }: NitRowProps) => {
  const { isAdmin, hasPermission } = useAuth();
  const canEdit = isAdmin || hasPermission("editar_nits");
  const canDelete = isAdmin || hasPermission("borrar_nits");
  return (
    <>
    <td className="px-4 py-3">
      <code className="rounded bg-slate-100 px-1.5 py-0.5 text-xs">
        {nit.nit}
      </code>
    </td>
    <td className="px-4 py-3 text-xs text-ink-secondary">
      {nit.dv ?? "—"}
    </td>
    <td className="px-4 py-3 font-medium text-ink-primary uppercase">
      {nit.razon_social}
    </td>
    <td className="px-4 py-3 text-ink-secondary">
      {nit.telefono ?? "—"}
    </td>
    <td className="px-4 py-3 text-ink-secondary">
      {nit.correo_electronico ?? "—"}
    </td>
    <td className="px-4 py-3 text-ink-secondary uppercase">
      {nit.ciudad ?? "—"}
    </td>
    <td className="px-4 py-3 text-ink-secondary uppercase">
      {nit.pais ?? "—"}
    </td>
      <td className="px-4 py-3">
        <div className="flex justify-end gap-2">
          <ActionButton
            color="blue"
            onClick={() => onView(nit)}
            aria-label={`Ver ${nit.razon_social}`}
          >
            Ver
          </ActionButton>
          {canEdit ? (
            <Link
              to={`/nits/${encodeURIComponent(nit.nit)}/editar`}
              className={actionLinkClasses("amber")}
              aria-label={`Editar ${nit.razon_social}`}
            >
              Editar
            </Link>
          ) : null}
          {canDelete ? (
            <ActionButton
              color="red"
              onClick={() => onDelete(nit)}
              aria-label={`Eliminar ${nit.razon_social}`}
            >
              Eliminar
            </ActionButton>
          ) : null}
        </div>
      </td>
    </>
  );
};